import React, { useState } from 'react';
import { ApplicationView } from '@aha-app/mvc';
import Tool, { type ToolButtonComponent } from './Tool';
import ToolButton from '../toolbars/ToolButton';

const ToggleFrameInNavigationButton: ToolButtonComponent = ApplicationView(
  ({ selection }) => {
    const [inNavigation, setInNavigation] = useState(
      !selection?.notInNavigation
    );

    // Determine which tool to use based on current state
    const currentTool = inNavigation
      ? ToolFrameInNavigation
      : ToolFrameNotInNavigation;

    return (
      <span>
        <ToolButton
          tool={currentTool}
          onClick={() => {
            selection?.toggleNotInNavigation?.();
            setInNavigation(!selection?.notInNavigation);
          }}
        >
          <i
            className={
              inNavigation ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash'
            }
          />
        </ToolButton>
      </span>
    );
  }
);

class ToolFrameInNavigation extends Tool {
  static toolName = 'Visible in frame navigation';

  static action({ selection }) {
    selection?.toggleNotInNavigation();
  }

  static enabled({ selection }) {
    return typeof selection.notInNavigation === 'boolean';
  }

  static buttonComponent() {
    return ToggleFrameInNavigationButton;
  }
}

class ToolFrameNotInNavigation extends Tool {
  static toolName = 'Hidden in frame navigation';

  static action({ selection }) {
    selection?.toggleNotInNavigation();
  }

  static enabled({ selection }) {
    return typeof selection.notInNavigation === 'boolean';
  }

  static buttonComponent() {
    return ToggleFrameInNavigationButton;
  }
}

export { ToolFrameInNavigation, ToolFrameNotInNavigation };
